<template>
    <v-card id="step-sidebar-card">
        <v-card-text v-if="step == 1">
                <v-row>
                    <v-col cols="10" style="display: flex; align-items: center;" id="topic_bottom">
                        <div class="pa-0 ma-0 prompt-title" >
                            {{ $t("message.formSummit.applicationForm") }}
                        </div>
                    </v-col>
                    <v-col cols="2" id="studentFormDropDown">
                        <v-btn icon @click="closeBar"
                            ><v-icon id="dropbar-icon" size="20"
                                >mdi-menu-down</v-icon
                            ></v-btn
                        >
                    </v-col>
                </v-row>
                <template v-if="this.closeActive">
                    <v-row>
                        <v-col id="subtopic_top" class="pb-0">
                            <div class="pa-0 prompt-caption">
                                {{ $t("message.formSummit.school") }}
                            </div>
                            <div
                                class="pa-0 mt-1 mb-c-14 text-caption"
                            >
                                {{ organization?.[`name_${locale}`] }}
                            </div>
                            <div class="pa-0 prompt-caption">{{ $t("message.formSummit.applicationPeriod")}}</div>
                            <div
                                v-if="registerTimeout"
                                class="pa-0 mt-1 mb-3 text-caption"
                            >
                                {{ openingDate }} - {{ closingDate }}
                            </div>
                            <div
                                v-else
                                class="pa-0 mt-1 mb-c-14 text-caption"
                                style="
                                    color: #ff544a;
                                "
                            >
                                {{ openingDate }} - {{ closingDate }}
                            </div>

                            <div class="pa-0 prompt-caption mb-c-14"
                            v-if="
                                    !(
                                        registrationFormDetail?.fee == 0 ||
                                        registrationFormDetail?.fee == null ||
                                        registrationFormDetail?.fee == undefined
                                    )
                                "
                                >{{ $t("message.formSummit.applicationFee")}}</div>
                            <div
                                class="pa-0 mt-1 mb-3 text-caption"
                                v-if="
                                    !(
                                        registrationFormDetail?.fee == 0 ||
                                        registrationFormDetail?.fee == null ||
                                        registrationFormDetail?.fee == undefined
                                    )
                                "
                            >
                                {{ registrationFormDetail?.fee }}
                                {{ $t("message.step2.baht") }}
                            </div>
                        </v-col>
                    </v-row>
                </template>
                <v-row class="mb-c-14">
                    <v-col cols="2" sm="1" md="2" class="ma-0 pr-0 pt-0 d-flex justify-sm-center justify-md-start"
                        ><v-checkbox
                            class="ma-0"
                            color="orange"
                            hide-details
                            v-model="is_consent"
                        ></v-checkbox>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="11"
                        md="10"
                        class="pl-0 pr-9 py-0 text-caption d-flex align-center"
                        style="line-height: 24px; margin-top:2px"
                        ><p>
                            {{ $t("message.formSummit.information") }}
                        </p></v-col
                    >
                </v-row>
                <v-row>
                    <v-col class="py-0">
                        <v-btn
                            class="prompt-24"
                            block
                            rounded
                            :color="
                                checkValidateForm && is_consent && registerTimeout
                                    ? '#FF9800'
                                    : '#AFADB1'
                            "
                            :disabled="
                                !(checkValidateForm && is_consent && registerTimeout)
                            "
                            @click="changeClickable()"
                            style="
                                color: white;
                                font-weight: 400;
                                font-size: 18px;
                                line-height: 24px;
                                letter-spacing: 0.05rem;
                            "
                            >{{ $t("message.formSummit.submitApplication") }}
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="pr-0 d-flex align-center pt-8 pb-5"
                        ><div
                            class="pa-0 mt-0 mx-auto"
                            style="
                                color: #37323c;
                                font-size: 14px !important;
                            "
                        >
                            Customer Service LINE
                        </div></v-col
                    >
                    <v-col class="pt-8 pb-5"
                        ><v-img
                            :src="require('../../assets/lineBtn.svg')"
                            contain
                            height="36"
                    /></v-col>
                </v-row>
        </v-card-text>
        <v-card-text v-else>
            <template>
                <v-row>
                    <v-col cols="10">
                        <div class="pa-0 prompt-title">
                            {{ $t("message.formSummit.applicationForm") }}
                        </div>
                    </v-col>
                    <v-col cols="2" id="studentFormDropDown">
                        <v-btn icon @click="closeBar"
                            ><v-icon id="dropbar-icon"
                                >mdi-menu-down</v-icon
                            ></v-btn
                        >
                    </v-col>
                </v-row>
                <template v-if="this.closeActive">
                    <div class="pa-0 prompt-caption">
                        {{ $t("message.formSummit.school") }}
                    </div>
                    <div
                        class="pa-0 mt-0 mb-3 text-caption"
                    >
                        {{ organization?.[`name_${locale}`] }}
                    </div>
                    <v-divider class="mt-5 mb-5"></v-divider>
                    <v-row>
                        <v-col cols="7" sm="6" md="6" class="py-0 mt-1"
                            ><div class="pa-0 mb-4 prompt-title">
                                {{ $t("message.formSummit.status") }}
                            </div></v-col
                        >
                        <v-col cols="5" sm="6" md="6" class="py-0 mt-1"
                            ><div
                                class="pa-0 mb-4 prompt-title d-flex justify-center"
                            >
                                <div v-if="type === 'pass'">
                                    <v-chip class="ma-0" color="#EBEBEC">
                                        <v-icon color="#00C487" left
                                            >mdi-checkbox-marked-circle</v-icon
                                        >
                                        <div class="prompt-chip pt-1">
                                            {{$t("message.formSummit.qualified")}}
                                        </div>
                                    </v-chip>
                                </div>
                                <div
                                    v-if="type === 'unpass'"
                                    class="pt-0"
                                    style="padding-top: 10px"
                                >
                                    <v-chip class="ma-0" color="#EBEBEC">
                                        <v-icon color="#FF544A" left
                                            >mdi-close-circle
                                        </v-icon>
                                        <div class="prompt-chip pt-1">
                                            {{$t("message.formSummit.noQualified")}}
                                        </div>
                                    </v-chip>
                                </div>
                                <div v-if="type === 'disclaim'">
                                    <v-chip class="ma-0" color="#EBEBEC">
                                        <v-icon color="#FF544A" left
                                            >mdi-close-circle</v-icon
                                        >
                                        <div class="prompt-chip pt-1">
                                            {{$t("message.formSummit.waiver")}}
                                        </div>
                                    </v-chip>
                                </div>
                            </div></v-col
                        >
                        <v-col cols="12" sm="6" md="6" class="py-0 my-0">
                            <div class="pa-0 prompt-caption">{{ $t("message.step4.topic.initiationDay") }}</div>
                            <div
                                v-if="enrollTimeout"
                                class="pa-0 mt-0 mb-3 text-caption"
                                style="
                                    color: #ff544a;
                                "
                            >
                                {{ enrollDate }}
                            </div>
                            <div
                                v-else
                                class="pa-0 mt-0 mb-3 text-caption"
                            >
                                {{ enrollDate }}
                            </div>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="py-0 mt-3">
                            <v-btn
                                class="mb-5 prompt-"
                                block
                                rounded
                                :color="
                                    checkFillForm
                                        ? '#FF9800'
                                        : '#AFADB1'
                                "
                                :disabled="!checkFillForm"
                                @click="changeClickable()"
                                height="40"
                                style="
                                    color: white;
                                    font-weight: 400;
                                    font-size: 18px;
                                    line-height: 24px;
                                "
                            >
                                {{ $t("message.step4.dialog.topic") }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pr-0 d-flex align-center"
                            ><div
                                class="pa-0 mt-0 mx-auto"
                                style="
                                    color: #37323c;
                                    font-size: 14px !important;
                                "
                            >
                                Customer Service LINE
                            </div></v-col
                        >
                        <v-col
                            ><v-img
                                :src="require('@/assets/lineBtn.svg')"
                                contain
                                height="36"
                        /></v-col>
                    </v-row>
                </template>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
import * as dateUtils from "@/utils/date";
import * as services from "@/services";
import dayjs from "dayjs";
import i18n from '@/i18n';
export default {
    name: "StudentForm",
    props: {
        clickable: Boolean,
        checkAutoFill: Boolean,
        registrationFormDetail: Object,
        checkValidateForm: Boolean,
        step: Number,
        result_type: String,
    },
    data() {
        return {
            is_consent: false,
            closeActive: true,
            type: "pass",
            organization: null,
        };
    },
    methods: {
        changeClickable() {
            this.$emit("changeClickable");
        },
        masterAutoFilled() {
            this.$emit("masterAutoFilled");
        },
        closeBar() {
            if (this.closeActive) {
                document.getElementById("dropbar-icon").style.transform =
                    "rotate(180deg)";
                document.getElementById("height-overflow").style.height =
                    "180px";
            } else {
                document.getElementById("dropbar-icon").style.transform =
                    "rotate(0deg)";
                document.getElementById("height-overflow").style.height =
                    "480px";
            }
            this.closeActive = !this.closeActive;
        },
        async fetchOrganizationInfo() {
            try {
                this.$emit("updateLoading", 1);
                let data = await services.getOrganization();
                this.organization = data.data.data.organization;
            } finally {
                this.$emit("updateLoading", -1);
            }
        },
    },
    computed: {
        locale() {
            return i18n.locale;
        },
        openingDate() {
            let newDate = Date.parse(this.registrationFormDetail?.opening_date);
            if (newDate) return dateUtils.formatDateTimeLocale(newDate, i18n.locale);
            else return "";
        },
        closingDate() {
            let newDate = Date.parse(this.registrationFormDetail?.closing_date);
            if (newDate) return dateUtils.formatDateTimeLocale(newDate, i18n.locale);
            else return "";
        },
        enrollDate() {
            let newDate = Date.parse(this.registrationFormDetail?.enrollment_date);
            if (newDate) return dateUtils.formatDateTimeLocale(newDate, i18n.locale);
            else return "";
        },
        enrollTimeout(){
            let newDate;
            if(this.result_type == "PASS"){
                newDate = new Date(this.registrationFormDetail?.announcement_exam_result_deadline_date);
                newDate.setDate(newDate.getDate() + 1);
                newDate = newDate.setHours(0)
            }
            else if(this.result_type == "RESERVED"){
                newDate = new Date(this.registrationFormDetail?.reserved_announcement_exam_result_deadline_date);
                newDate.setDate(newDate.getDate() + 1);
                newDate = newDate.setHours(0)
            }
            if (newDate) return !dayjs(new Date()).isSameOrBefore(dayjs(newDate))
            return true;
        },
        registerTimeout() {
            // true is not timeout
            let newDate = new Date(`${this.registrationFormDetail?.closing_date} ${this.registrationFormDetail?.closing_time}:00`);
            //newDate.setDate(newDate.getDate() + 1);
            //newDate = newDate.setHours(0)
            if (newDate) return dayjs(new Date()).isSameOrBefore(dayjs(newDate))
            return false;
        },
        confirmationTimeout() {
            let deadlineConfirmationDate = new Date(
                this.registrationFormDetail
                    ?.announcement_exam_result_deadline_date
            );
            deadlineConfirmationDate.setDate(deadlineConfirmationDate.getDate() + 1);
            deadlineConfirmationDate = deadlineConfirmationDate.setHours(0)
            if (
                dayjs(new Date()).isSameOrBefore(
                    dayjs(deadlineConfirmationDate)
                )
            ) {
                return false;
            }
            return true;
        },
        reservedConfirmationTimeout() {
            let deadlineConfirmationDate = new Date(
                this.registrationFormDetail
                    ?.reserved_announcement_exam_result_deadline_date
            );
            deadlineConfirmationDate.setDate(deadlineConfirmationDate.getDate() + 1);
            deadlineConfirmationDate = deadlineConfirmationDate.setHours(0)
            if (
                dayjs(new Date()).isSameOrBefore(
                    dayjs(deadlineConfirmationDate)
                )
            ) {
                return false;
            }
            return true;
        },
        checkFillForm(){
            return this.checkValidateForm && (!this.enrollTimeout)
        }
    },
    mounted() {
        this.fetchOrganizationInfo();
    },
};
</script>

<style scoped lang="scss">
.theme--light.v-icon.mdi-checkbox-blank-outline {
    color: #ff9800;
}

#studentFormDropDown{
    display: none;
}

@media only screen and (max-width: 959.98px) {
    #studentFormDropDown{
        display: block;
    }
}

#topic_bottom{
    padding-bottom: 7px;
}

#subtopic_top{
    padding-top: 7px;
}

/* margin custom 14*/
.mb-c-14{
    margin-bottom: 14px;
}

.text-caption{
    color: #37323c;
    font-family: 'Sarabun' !important;
    font-size: 18px !important;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}

</style>
